import { createSlice } from '@reduxjs/toolkit';

export const scheduleEditorSlice = createSlice({
	name: 'scheduleEditor',
	initialState: {
		scheduleData: {
			lastDateSelected: false,
		},
		template: {
			name: '',
			workouts: [],
		},
	},
	reducers: {
		setScheduleData: (state, action) => {
			state.scheduleData = action.payload.scheduleData;
		},
		setTemplate: (state, action) => {
			state.template = {
				...state.template,
				...action.payload,
			};
		},
		clearScheduleData: (state, action) => {
			state.scheduleData = {
				lastDateSelected: false,
			};
		},
		clearTemplate: (state, action) => {
			state.template = {
				name: '',
				workouts: [],
			};
		},
	},
});

export const {
	setScheduleData,
	setTemplate,
	clearScheduleData,
	clearTemplate,
} = scheduleEditorSlice.actions;

export default scheduleEditorSlice.reducer;
